module.exports = __webpack_public_path__ + "static/media/6.c49326b3.jpg";